import { IsNotEmpty, IsString } from '@viterbit/web-app/shared/utils/ClassValidators'

import { EmployeeProfileAccountFormFields } from './EmployeeProfileAccountForm'

export class EmployeeProfileAccountValidator  implements EmployeeProfileAccountFormFields {
    id: string
    @IsString()
    @IsNotEmpty()
    roleId: string
}